// PatternLab Dashboard API Configuration
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_PATTERNLAB_API_BASE_URL || 'https://patternlab-dashboard-api.logic-joe.com',
  API_KEY: process.env.REACT_APP_PATTERNLAB_API_KEY || 'your-super-secret-production-api-key-2025',
  TIMEOUT: 30000,
} as const;

// Environment-specific configuration
export const getApiConfig = () => {
  const isDevelopment = process.env.NODE_ENV === 'development';
  
  return {
    ...API_CONFIG,
    // Override API key in development if needed
    API_KEY: isDevelopment 
      ? (process.env.REACT_APP_PATTERNLAB_API_KEY || API_CONFIG.API_KEY)
      : API_CONFIG.API_KEY,
  };
};
